import { gql } from '@apollo/client';

export const GET_SEARCH = gql(`
    query navigation_Search($query: String!) {
        search(query:  $query) {
            ... on navigation_Standort {
                id
                name
            }
            ... on navigation_Mitarbeiter {
                bildUrl
                id
                nachname
                standort
                type
                vorname
                personalnummer
                extern
            }
        }
    }
`);
